import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PaginatedDto, PaginationParamsDto, QuizQuestionDto } from '../models';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getQuizQuestions(value: PaginationParams): Observable<PaginatedDto> {
        return this.httpClient
            .get<QuizQuestionDto[]>('quiz-questions', {
                params: new PaginationParamsDto(value).params,
                observe: 'response',
            })
            .pipe(map((response) => new PaginatedDto(response)));
    }
}
